import { fetcher as createFetcher, FunctionPropTypes } from 'ui'

export const fetcher = <T>(props: FunctionPropTypes<typeof createFetcher>) => {
  return createFetcher<T>(props)
}

export default fetcher
